/**
 * OverUnderStrip.jsx
 * 
 * Phase 2F5 - Extracted from GMRosterBuilderV2
 * Displays over/under allocation breakdown as a horizontal bar.
 * 
 * BSL Compliant: Indigo for over, slate for under - no judgment colors.
 */

import React from 'react';

/**
 * @param {Object} props
 * @param {Array} props.roster - Roster array with side and units
 */
const OverUnderStrip = ({ roster }) => {
  const filled = roster.filter(s => s.player);
  const totalUnits = filled.reduce((s, r) => s + r.units, 0);
  
  if (totalUnits === 0) return null;
  
  const overUnits = filled
    .filter(s => s.side === 'OVER')
    .reduce((s, r) => s + r.units, 0);
  
  return (
    <div className="flex h-2.5 rounded-full overflow-hidden">
      <div 
        className="h-full bg-indigo-500" 
        style={{ width: `${(overUnits / totalUnits) * 100}%` }} 
      />
      <div 
        className="h-full bg-slate-400" 
        style={{ width: `${((totalUnits - overUnits) / totalUnits) * 100}%` }} 
      />
    </div>
  );
};

export default OverUnderStrip;
